
export const SET_SELECTED_USER = 'SET_SELECTED_USER'
export const SET_SELECTED_USER_SUCCESS = 'SET_SELECTED_USER_SUCCESS'
export const SET_SELECTED_USER_ERROR = 'SET_SELECTED_USER_ERROR'

export const SetSelectedUser = (data) => ({
  type: SET_SELECTED_USER,
  payload: data
})
